import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'

export const NotFoundPage = () => (
	<div className='flex min-h-[60vh] flex-col items-center justify-center text-center'>
	<p className='text-sm font-semibold text-primary'>404</p>
	<h1 className='mt-2 text-2xl font-semibold sm:text-3xl'>Страница не найдена</h1>
	<p className='mt-2 text-sm text-muted-foreground'>Проверьте адрес раздела или вернитесь на главную.</p>
	<Button asChild variant='outline' className='mt-5'><Link to='/'>На главную</Link></Button>
	</div>
)
